import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import withModal from '../../../../../../../../../../../components/global/modal/withModal';
import ShoppingBasketIcon from '../../../../../../../../../../../components/icons/ShoppingBasketIcon';
import Button from '../../../../../../../../../../../components/global/Button';
import CheckboxIcon from '../../../../../../../../../../../components/icons/CheckboxIcon';
import Badge from '../../../../../../../../../../../components/global/Badge';
import { getCheckoutCartTotalItems } from '../../../../../../../../../../../services/checkout/redux/checkoutSelectors';

const propTypes = {
  className: PropTypes.string,
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCheckout: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

const PrintProductSizeSuccess = ({
  className,
  accountCard,
  onCheckout,
  onDismiss,
}) => {
  const totalCartItems = useSelector(getCheckoutCartTotalItems);

  const classes = classNames({
    [className]: !!className,
    'print-product-size-success': true,
  });

  return (
    <div className={classes}>
      <div className="print-product-size-success-header">
        <span className="print-product-size-success-header-icon">
          <ShoppingBasketIcon />
          <CheckboxIcon />
        </span>
        <h4>
          {(
            accountCard?.print_product_configuration?.print_product?.name ?? ''
          ).replace(' (configured as rendered sheets)', '')}
        </h4>
        <p>has been added to your cart!</p>
      </div>

      <p className="text-italic text-sm">
        You can change quantities or delete items from your cart.
      </p>

      <div className="print-product-size-success-actions">
        <Button
          btnBlock
          btnSize="lg"
          onClick={onCheckout}
          btnStyle="success-vibrant"
          className="btn-checkout-print-product-size-success"
        >
          <span className="purchasing-options-list-btn-shopping-cart-icon">
            <ShoppingBasketIcon />
            {totalCartItems > 0 && (
              <Badge badgeStyle="danger" badgeSize="xs" round>
                {totalCartItems}
              </Badge>
            )}
          </span>
          Check out now
        </Button>
        <Button
          btnBlock
          btnSize="lg"
          btnOutline
          onClick={onDismiss}
          className="btn-checkout-print-product-size-success"
        >
          Continue shopping
        </Button>
      </div>
    </div>
  );
};

PrintProductSizeSuccess.propTypes = propTypes;

export default withModal(PrintProductSizeSuccess, {
  size: 'xs',
  hideHeader: true,
  dismissible: false,
  shouldCloseOnOverlayClick: false,
  className: 'print-product-size-success-modal-wrap',
});
